const BaseModel = require('../BaseModel');
const BaseEntityFilter = require('./BaseEntityFilter');

class MatchAnyEntityFilter extends BaseEntityFilter {
  static dataType = 'match-any-value-filter';
  constructor(json={}) {
    super(json);

    this.isValid = this.isValid.bind(this);
  }

  isValid() {
    this.errors = [];

    if(!this.entity) { this.errors.push(['entity', 'Is not set']) }
    if(undefined === this.values || null === this.values || this.values.length == 0) {
      this.errors.push(['values', 'No value(s) have been provided']);
    }

    return(this.errors.length == 0);
  }
}

BaseModel.models[MatchAnyEntityFilter.dataType] = MatchAnyEntityFilter;
module.exports =  MatchAnyEntityFilter;
